// extracted by mini-css-extract-plugin
module.exports = {"container":"companyGrid_container__1F6i2","card":"companyGrid_card__2ce9z","placeholder":"companyGrid_placeholder__312hK"};